import { PdfExportDomain } from '@mode/shared/contract-common';
import { createReducer, on } from '@ngrx/store';
import * as PdfExportActions from './pdf-export.action';

export interface PdfExportState {
  reportRunToken: string | null;
  filename: string | null;
  state: PdfExportDomain.PdfExportState | null;
  error: Error | null;
  downloadLink: string | null;
}

export const initialState: PdfExportState = {
  reportRunToken: null,
  filename: null,
  state: null,
  error: null,
  downloadLink: null,
};

export const pdfExportReducer = createReducer(
  initialState,
  on(PdfExportActions.createPdfExport, (state, action) => ({
    ...state,
    reportRunToken: action.reportRunToken,
    filename: null,
    state: null,
    error: null,
    downloadLink: null,
  })),
  on(PdfExportActions.createPdfExportSuccess, (state, action) => ({
    ...state,
    filename: action.pdfExport.filename,
    state: action.pdfExport.state,
    downloadLink: action.pdfExport.downloadLink,
  })),
  on(PdfExportActions.createPdfExportFailed, (state, action) => ({
    ...state,
    state: action.state || null,
    error: action.error,
  }))
);
